import React from 'react';

export const PlayerContext = React.createContext(null);

export function usePlayer() {
  return React.useContext(PlayerContext);
}
